<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ABR"></a></p>
<h1>Chief abbreviations</h1>
<p>Of the many commentaries on the Corinthian correspondence, the following were most frequently consulted:</p>
<table class="Abbr">
<tbody><tr>
<td>Allo</td>
<td>Le P. E.-B. Allo, <span class="FrenchWord" xml:lang="fr">Saint Paul, Première Épître aux Corinthiens</span> (J. Gabalda, Paris, 1956).</td>
</tr>
<tr>
<td>Barclay</td>
<td>W. Barclay, <em>The Letters to the Corinthians</em> (<em>The Daily Study Bible</em>, The Saint Andrew Press, 1954).</td>
</tr>
<tr>
<td>Barrett</td>
<td>C. K. Barrett, <em>A Commentary on the First Epistle to the Corinthians</em> (<em>Black’s New Testament Commentaries</em>, A. &amp; C. Black, 1968).</td>
</tr>
<tr>
<td>Bruce</td>
<td>F. F. Bruce, <em>1 and 2 Corinthians</em> (<em>The New Century Bible Commentaries</em>, Eerdmans and Marshall, Morgan &amp; Scott, 1971).</td>
</tr>
<tr>
<td>Conzelmann</td>
<td>Hans Conzelmann, <em>1 Corinthians</em> (Hermeneia, Fortress Press, 1975).</td>
</tr>
<tr>
<td>Dods</td>
<td>Marcus Dods, <em>The First Epistle to the Corinthians</em> (<em>The Expositor’s Bible</em>, Hodder &amp; Stoughton, 1889).</td>
</tr>
<tr>
<td>Godet</td>
<td>F. Godet, <em>Commentary on St Paul’s First Epistle to the Corinthians</em> (T. &amp; T. Clark, 1889), 2 volumes.</td>
</tr>
<tr>
<td>Goudge</td>
<td>H. L. Goudge, <em>The First Epistle to the Corinthians</em> (<em>Westminster Commentaries</em>, Methuen, 1903).</td>
</tr>
<tr>
<td>Hodge</td>
<td>Charles Hodge, <em>A Commentary on the First Epistle to the Corinthians</em> (<em>Geneva Series</em>, Banner of Truth, 1958).</td>
</tr>
<tr>
<td>Morgan</td>
<td>G. Campbell Morgan, <em>The Corinthian Letters of Paul</em> (Oliphants, 1947).</td>
</tr>
<tr>
<td>Morris</td>
<td>L. Morris, <em>1 Corinthians</em> (<em>Tyndale New Testament Commentaries</em>, Inter-Varsity Press, 1958).</td>
</tr>
<tr>
<td>Ruef</td>
<td>John S. Ruef, <em>Paul’s First Letter to Corinth</em> (<em>Pelican New Testament Commentaries</em>, Penguin, 1971).</td>
</tr>
</tbody></table>
<p>In addition, considerable use was made of Arnold Bittlenger, <em>Gifts and Graces</em> (Eng. tr., Hodder &amp; Stoughton, 1967)—an exegetical commentary on chapters 12 to 14.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ABR.vue?794365ee